import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import Text from 'components/Text';
import { FONT_SIZES, COLOR } from 'config';
import { FormattedHTMLMessage } from 'react-intl';
import Title from './Title';
import image from '../images/FB-Landing-Page-graphic1b.png';
import Card from './Card';
import { ImageCardContainer } from './ImageCard';

const StyledText = styled(Text)`
  line-height: 2.35rem;
  ul {
    font-size: ${rem(FONT_SIZES[5])};
    line-height: 2.35rem;
  }
`;

const Presentation = () => {
  const icon = (
    <ImageCardContainer
      image={image}
      height="calc(400px + 3rem)"
      width="480"
      backgroundColor={COLOR.base}
      // backgroundPositionX={'-50px'}
    />
  );

  return (
    <Card image={icon} mb={'3rem'} noMargin>
      <Title id="Speech about Skycoin" />
      <StyledText>
        <FormattedHTMLMessage id="Watch a talk and presentation that will detail all the components of the Skycoin ecosystem and how they synergistically come together to enable a revolution in the way we do Internet. Learn about the philosophy behind Skycoin, how it solves issues that other cryptos struggle with and become familiar with Skycoin's strategy for deploying the new Internet." />
      </StyledText>
    </Card>
  );
};

export default Presentation;



// WEBPACK FOOTER //
// ./src/components/NYCMeetUpLanding/components/Presentation.js